import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import aggregacao from "../aggregacao";
import chartConfig from "../chartConfig";
import { parseLabelCampo } from "../../../../constants/metricas";

export default class TreemapComparativo extends Component {

    constructor(props) {
        super(props);
    }

    // Agrupa por `sigla` (código curto, ex. "SL", "CITI/CAM"), não pelo nome
    // completo da unidade. Motivo (achado lendo o código-fonte do ApexCharts,
    // `modules/dimensions/XAxis.js:additionalPaddingXLabels`): mesmo o
    // treemap não desenhando eixo X nenhum, a lib mede o texto mais longo
    // entre os valores `x` dos pontos (aqui, os nomes de unidade) pra reservar
    // espaço pra "o último rótulo do eixo X não cortar" -- uma checagem que
    // não exclui o tipo `treemap`. Com nomes longos (ex. "CITI/CAM CENTRO DE
    // INOV. E TEC. INDUSTRIAL"), sobra um espaço em branco grande à direita
    // das caixas, desalinhado com os elementos acima (bug real, confirmado
    // isolando a variável: trocar os nomes por textos curtos elimina o
    // espaço quase por completo). Usar a sigla resolve os dois problemas de
    // uma vez: reservado praticamente some, e o texto passa a caber dentro
    // de caixas pequenas sem precisar rotacionar (a `sigla` já é o padrão
    // usado no resto do app pra identificar unidade em espaço curto).
    montaSeries = () => {
        let { linhas, campo, mes } = this.props;
        let somas = aggregacao.somaPorGrupo(linhas || [], "sigla", campo, mes);
        return [{ data: aggregacao.paraSerieTreemap(somas) }];
    }

    render() {
        let { campo } = this.props;
        let options = chartConfig.optionsBase({ titulo: parseLabelCampo(campo), tipo: "treemap" });

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <Chart options={options} series={this.montaSeries()} type="treemap" height={350} />
                    </div>
                </div>
            </Fragment>
        )
    }
}
